import { FacilityGroupTableElementProps } from "../../../../FacilityGroup/entities";

export const _styledTBody: React.FC<FacilityGroupTableElementProps> = ({ children }) => {
    return (
        <tbody>
            {children}
        </tbody>
    )
};